import { ref } from "vue";

export const UPLOAD_STATUS = {
  JUST_ADDED: "just_added",
  UPLOADING: "uploading",
  PENDING: "pending",
  DONE: "done",
  ERROR: "error",
};

const IN_PROGRESS_STATUSES = [UPLOAD_STATUS.JUST_ADDED, UPLOAD_STATUS.UPLOADING, UPLOAD_STATUS.PENDING];

// Module-level singleton so the monitor persists across route/panel changes,
// same idea as the old app's global upload store.
const files = ref([]); // { id, projectId, name, mimeType, status, message, documentId, file }
const isVisible = ref(false);
const isMinimized = ref(false);

export function useUploadMonitor() {
  function addFiles(entries) {
    files.value.push(...entries);
    if (entries.length) {
      isVisible.value = true;
      isMinimized.value = false;
    }
  }

  function updateStatus(id, status, message = "", documentId = null) {
    const entry = files.value.find((f) => f.id === id);
    if (!entry) return;
    entry.status = status;
    entry.message = message;
    if (documentId) entry.documentId = documentId;
  }

  function hide() {
    isVisible.value = false;
    // Drop anything already finished/errored; keep in-flight uploads tracked.
    files.value = files.value.filter((f) => IN_PROGRESS_STATUSES.includes(f.status));
  }

  function toggleMinimize() {
    isMinimized.value = !isMinimized.value;
  }

  return { files, isVisible, isMinimized, addFiles, updateStatus, hide, toggleMinimize };
}
